import { rem } from 'polished'
import { useCallback } from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'

import SelectItemToAdd from './TripItems/SelectItemToAdd'

import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import IconButton from 'LuxKit/Button/IconButton'
import TextButton from 'LuxKit/Button/TextButton'
import LineTimesIcon from 'LuxKit/Icons/line/LineTimesIcon'
import BodyText from 'LuxKit/Typography/BodyText'
import Heading from 'LuxKit/Typography/Heading'
import Group from 'components/utils/Group'
import useToggle from 'hooks/useToggle'
import useOpenModal from 'tripPlanner/hooks/View/useOpenModal'

const Root = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  min-width: ${rem(366)};
  padding: ${rem(16)};
  transform: translate(-50%, -50%);
  background: ${props => props.theme.palette.neutral.default.eight};
  border-radius: ${(props) => props.theme.borderRadius.M};
  box-shadow: ${props => props.theme.shadow.bottom.large};
`

const Buttons = styled.div`
  display: flex;
  justify-content: flex-end;
`
interface Props {
  tripId: string
}

export default function TooltipModal({ tripId }: Props) {
  const intl = useIntl()
  const [isOpen, , , close] = useToggle(true)

  const openModal = useOpenModal()

  const onAddToTrip = useCallback(
    () => openModal(SelectItemToAdd, { tripId }),
    [openModal, tripId],
  )

  if (!isOpen) {
    return null
  }

  return (
    <Root>
      <VerticalSpacer gap={8}>
        <Group
          direction="horizontal"
          verticalAlign="center"
          horizontalAlign="space-between"
        >
          <Heading variant="heading6">
            {intl.formatMessage({
              id: 'vhGUsrUH-H8qNHB4jhGq',
              defaultMessage: 'Add something to your trip!',
              description: 'Tooltip heading encouraging user to add items to their trip',
            })}
          </Heading>

          <Group direction="horizontal" verticalAlign="center">
            <IconButton
              kind="tertiary"
              variant="dark"
              size="small"
              shape="circle"
              data-testid="action-menu-button"
              aria-label={intl.formatMessage({
                id: 'Ba3dv0lOHK-h1inkSNmR',
                defaultMessage: 'Card action menu',
                description: 'Accessibility label for the close button on trip tooltip',
              })}
              onClick={close}
            >
              <LineTimesIcon />
            </IconButton>
          </Group>
        </Group>

        <BodyText variant="medium">
          {intl.formatMessage({
            id: 'bCaHsgzwtID5y24wQMWo',
            defaultMessage: 'Try adding a hotel or flight',
            description: 'Suggestion text in the trip tooltip for adding items',
          })}
        </BodyText>
        <Buttons>
          <TextButton
            shape="round"
            kind="primary"
            variant="ghost"
            onClick={onAddToTrip}
          >
            {intl.formatMessage({
              id: 'RU7LfDzVgfTsjmEaTeRh',
              defaultMessage: 'Add to trip',
              description: 'Button to open the add item to trip modal in the trip planner',
            })}
          </TextButton>
        </Buttons>
      </VerticalSpacer>
    </Root>
  )
}
